import React from 'react';
import '../styles/SectionFour.css';

const points = [
  'Workout from home',
  'No gym',
  'Minimal equipment',
  'Workout anytime',
];

export function SectionFour() {
  return (
    <section className="section-four" id="why-it-works">
      <div className="section-four__container">
        <div className="section-four__image-wrap">
          <img src="/assets/section4.png" alt="Fitness transformation" />
        </div>
        <div className="section-four__content">
          <h2 className="section-four__title">Why the Get Fit with Daniella Method Works</h2>
          <ul className="section-four__list">
            {points.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default SectionFour;
